export default __webpack_public_path__ + "static/media/harmay-logo.e364ef62.png";